import { getDateLocale } from "../../i18n/languages";

// Deterministic visual styling for a news item based on its appKey, so
// cards get consistent colors / cover gradients without needing an image
// field from the backend.
const PALETTE = [
  { from: "#4f7cff", to: "#22d3ee" },
  { from: "#a855f7", to: "#ec4899" },
  { from: "#22c55e", to: "#22d3ee" },
  { from: "#f59e0b", to: "#ef4444" },
  { from: "#6366f1", to: "#8b5cf6" },
];

function hashString(str = "") {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function getNewsVisual(item) {
  const seed = hashString(item.appKey || item.title || String(item.id || ""));
  const c = PALETTE[seed % PALETTE.length];
  return {
    gradient: `linear-gradient(135deg, ${c.from}, ${c.to})`,
    from: c.from,
    to: c.to,
  };
}

export function formatNewsDate(value, lang = "en") {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value; // backend may send a plain string
  try {
    return d.toLocaleDateString(getDateLocale(lang), {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return value;
  }
}
